import formatDecimal from "./formatDecimal.js";

export default function(x) {
  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-format/src/exponent.js
// module id = G46r
// module chunks = 0